// SSOHandler.js - Componente para capturar e validar tokens SSO
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SSOHandler = ({ onLogin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('[SSO DEBUG] SSOHandler montado');

    const urlParams = new URLSearchParams(window.location.search);
    const ssoToken = urlParams.get('sso_token');

    console.log('[SSO DEBUG] sso_token na URL?', ssoToken ? 'SIM' : 'NÃO');

    if (ssoToken) {
      console.log('[SSO] Token SSO detectado!');
      const API = process.env.REACT_APP_API_URL || 'http://localhost:8001';

      // 1) Preferir user normalizado do backend (agora já retorna role)
      fetch(`${API}/api/auth/me`, {
        headers: { 'Authorization': `Bearer ${ssoToken}` }
      })
        .then(res => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then(userData => {
          console.log('[SSO] Usuário do backend:', userData);
          if (!userData.role) {
            userData.role = deriveRoleFromPayload(userData);
          }
          onLogin(ssoToken, userData);
          window.history.replaceState({}, document.title, window.location.pathname);
          // Usar navigate do React Router em vez de window.location.href
          navigate('/dashboard', { replace: true });
        })
        .catch(() => {
          // 2) Fallback: decodificar token e inferir role
          try {
            const payload = decodeJwt(ssoToken);
            const userData = {
              id: payload.sub,
              email: payload.email,
              permissions: payload.permissions || [],
              is_superadmin: !!payload.is_superadmin,
              role: deriveRoleFromPayload(payload)
            };
            console.log('[SSO] Usuário do token:', userData);
            onLogin(ssoToken, userData);
            window.history.replaceState({}, document.title, window.location.pathname);
            // Usar navigate do React Router em vez de window.location.href
            navigate('/dashboard', { replace: true });
          } catch (err) {
            console.error('[SSO] Erro ao processar token:', err);
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/login', { replace: true });
          }
        });
    } else {
      console.log('[SSO DEBUG] Nenhum token SSO encontrado, fluxo normal');
    }
  }, [navigate]);

  return null; // Não renderiza nada
};

function decodeJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map(c =>
    '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  ).join(''));
  return JSON.parse(jsonPayload);
}

function deriveRoleFromPayload(payload) {
  if (payload?.is_superadmin) return 'ADMIN';
  const perms = payload?.permissions || [];
  const disc = perms.find(p => String(p.system || '').toUpperCase() === 'DISC' && (p.enabled ?? true));
  return disc?.role || null;
}

export default SSOHandler;

